import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';

export const RatingStars = ({value, setValue}) => {
  return (
    <Box >
      <Rating
        name="simple-controlled"
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      />
    </Box>
  );
}